(function () {
  var cfgEl = document.getElementById('pz-cart-config');
  if (!cfgEl || window.PZCart) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var threshold = cfg.threshold || 7000;
  var ROLL = '5-Pack Roll', CAN = 'Single Can';
  var cart = null, busy = false, lastStrength = null, flavorCache = null, wasFree = false;
  // Free shipping is US-only. Shopify's geo lookup says where the shopper is; until it answers, assume US.
  // Outside the US the cart drops the Free Shipping step, the banner and the FREE label.
  var usShip = true;
  try { var savedCc = sessionStorage.getItem('pzc-cc'); if (savedCc) usShip = savedCc === 'US'; } catch (e) {}
  fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      var cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
      if (!cc) return;
      try { sessionStorage.setItem('pzc-cc', cc); } catch (e) {}
      var was = usShip;
      usShip = cc === 'US';
      if (was !== usShip && cart) render();
    })
    .catch(function () {});
  // Free gift tiers (koozie at $50, hat at $100), each a Shopify automatic discount
  var gifts = cfg.gifts || [];
  var tierByProduct = {}, itemByProduct = {}, tierByKey = {};
  gifts.forEach(function (g) {
    tierByKey[g.key] = g;
    (g.items || []).forEach(function (h) { tierByProduct[h.product_id] = g; itemByProduct[h.product_id] = h; });
  });
  function tierOf(it) { return tierByProduct[it.product_id] || null; }

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function mg(s) { return String(s || '').replace(/mg/i, '').trim() + ' mg'; }
  function track(name, p) { if (window.pzTrack) window.pzTrack(name, p); }
  // Labels the next cart change for pz-analytics.js, which sends add_to_cart / remove_from_cart for every change
  function ctx(list) { if (window.PZA) window.PZA.ctx = { item_list_name: list }; }

  // ---------- shell ----------
  // The rewards bar sits between the header and the scrolling body, so it stays put while the cart scrolls
  var drawer = document.createElement('div');
  drawer.className = 'pzc';
  drawer.innerHTML =
    '<div class="pzc-overlay" data-pzc-close></div>' +
    '<aside class="pzc-panel" role="dialog" aria-modal="true" aria-labelledby="pzc-title" tabindex="-1">' +
      '<div class="pzc-head"><h2 id="pzc-title">Your cart <span data-pzc-count></span></h2>' +
      '<button type="button" class="pzc-x" data-pzc-close aria-label="Close cart"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="pzc-rwbar" data-pzc-rw></div>' +
      '<div class="pzc-body" data-pzc-body></div>' +
      '<div class="pzc-foot" data-pzc-foot></div>' +
    '</aside>';

  var pageRoot = document.querySelector('[data-pz-cart-page]');
  var mount = pageRoot || drawer;
  if (!pageRoot) document.body.appendChild(drawer);
  else {
    pageRoot.classList.add('pzc', 'pzc-page');
    pageRoot.innerHTML = '<div class="pzc-panel"><div class="pzc-head"><h2>Your cart <span data-pzc-count></span></h2></div><div class="pzc-rwbar" data-pzc-rw></div><div class="pzc-body" data-pzc-body></div><div class="pzc-foot" data-pzc-foot></div></div>';
  }
  var rwEl = mount.querySelector('[data-pzc-rw]');
  var body = mount.querySelector('[data-pzc-body]');
  var foot = mount.querySelector('[data-pzc-foot]');
  var countEl = mount.querySelector('[data-pzc-count]');

  // ---------- data ----------
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', pzc: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }
  // Set a row's quantity: the first line gets it all, any split-off lines go to 0
  function setRowQty(keys, qty) {
    if (keys.length === 1) return change(keys[0], qty);
    var updates = {};
    keys.forEach(function (k, i) { updates[k] = i === 0 ? qty : 0; });
    return fetch('/cart/update.js', {
      method: 'POST', pzc: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }
  function add(id, qty, props) {
    var item = { id: id, quantity: qty };
    if (props) item.properties = props;
    return fetch('/cart/add.js', {
      method: 'POST', pzc: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json(); });
  }

  // ---------- free gifts ----------
  function isGiftItem(it) { return !!tierByProduct[it.product_id]; }
  function isGiftLine(it) {
    return isGiftItem(it) && ((it.properties && it.properties._pz_gift) || it.final_line_price < it.original_line_price);
  }
  // Leftover BOGOS gift lines (its $0 "🎁 … (100% off)" copies) from before the switch
  function isBogos(it) { return /sca_clone_freegift/.test(it.handle || '') || (it.original_price === 0 && /\(100% off\)/i.test(it.product_title || '')); }
  function cleanTitle(t) { return String(t || '').replace(/^\s*🎁\s*/, '').replace(/\s*\(100% off\)\s*$/i, ''); }
  // Goods that count toward the free gifts: everything paid for except koozies, hats and gift cards.
  // The koozie and hat are order-level discounts ("Free koozie" = $6 off at $56+, "Free hat" = $15 off at $115+,
  // i.e. $50 / $100 of goods plus the gift itself), so every paid item counts, Buy 3 Get 2 tins included.
  function giftProgress() {
    var sub = 0;
    cart.items.forEach(function (it) { if (!isGiftItem(it) && !isBogos(it) && !it.gift_card) sub += it.final_line_price; });
    return sub;
  }
  function currentGift(g) {
    for (var i = 0; i < cart.items.length; i++) if (tierOf(cart.items[i]) === g && isGiftLine(cart.items[i])) return cart.items[i];
    return null;
  }
  // Keep the cart honest: drop picked gifts below their threshold, never more than one picked gift per tier
  function enforceGift() {
    var prog = giftProgress();
    var jobs = [];
    gifts.forEach(function (g) {
      var tagged = cart.items.filter(function (it) { return tierOf(it) === g && it.properties && it.properties._pz_gift; });
      var unlocked = prog >= g.threshold;
      tagged.forEach(function (it, i) {
        if (!unlocked || i > 0) jobs.push([it.key, 0]);
        else if (it.quantity > 1) jobs.push([it.key, 1]);
      });
    });
    if (!jobs.length) return Promise.resolve(false);
    return jobs.reduce(function (p, j) { return p.then(function () { return change(j[0], j[1]); }); }, Promise.resolve())
      .then(function () { return true; });
  }
  // ---------- Buy 3 Get 2 single tins (Shopify automatic discount BUY3GET2CAN) ----------
  // Every 3 paid single tins earns 2 free ones. Picked free tins are normal single-tin lines tagged _pz_free;
  // the discount makes them $0 at checkout. Free tins never count toward the next 3, and only variants the
  // discount can make free (cfg.b3g2.get) are offered in the picker.
  var b3 = cfg.b3g2 || null, B3_BUY = {}, B3_GET = {}, tinNote = '', pick = { flv: null, v: null }, prevNeed = 0, b3Open = false;
  if (b3) {
    (b3.buy || []).forEach(function (id) { B3_BUY[id] = 1; });
    (b3.get || []).forEach(function (id) { B3_GET[id] = 1; });
  }
  function isTin(it) { return !!(b3 && B3_BUY[it.variant_id]); }
  function isFreeTin(it) { return isTin(it) && !!(it.properties && it.properties._pz_free); }
  function tinState() {
    var per = (b3 && b3.per) || 3, gets = (b3 && b3.gets) || 2, limit = (b3 && b3.limit) || 0;
    var s = { paid: 0, free: 0, disc: 0, unit: 0, per: per, gets: gets, limit: limit, earned: 0, need: 0, sets: 0, maxed: false };
    if (!b3 || !cart) return s;
    cart.items.forEach(function (it) {
      if (!isTin(it)) return;
      if (isFreeTin(it)) s.free += it.quantity; else s.paid += it.quantity;
      if (!s.unit) s.unit = it.original_price;
      s.disc += it.original_line_price - it.final_line_price;
    });
    s.sets = Math.floor(s.paid / per);
    if (limit) s.sets = Math.min(s.sets, limit);
    s.maxed = !!limit && s.sets >= limit;
    s.earned = s.sets * gets;
    s.need = Math.max(0, s.earned - s.free);
    s.toNext = per - (s.paid % per);
    return s;
  }
  // Too many free tins for the paid ones (a paid tin was removed): drop the newest free tins first.
  // A free tag on a variant the discount can't make free is dropped too.
  function enforceTins() {
    if (!b3) return Promise.resolve(false);
    var s = tinState(), extra = s.free - s.earned, jobs = [];
    cart.items.forEach(function (it) {
      if (!isFreeTin(it)) return;
      if (!B3_GET[it.variant_id]) { jobs.push([it.key, 0]); extra -= it.quantity; return; }
      if (extra > 0) { var cut = Math.min(extra, it.quantity); jobs.push([it.key, it.quantity - cut]); extra -= cut; }
    });
    if (!jobs.length) return Promise.resolve(false);
    tinNote = s.earned ? 'We removed a free tin so it matches your paid tins.' : 'Your free tins were removed. Get to 3 paid tins to unlock them again.';
    return jobs.reduce(function (p, j) { return p.then(function () { return change(j[0], j[1]); }); }, Promise.resolve())
      .then(function () { return true; });
  }
  // Show the tin discount on the free rows first, then on paid tins, so the rows always add up to Shopify's total
  function tinPrices(rows) {
    if (!b3) return;
    var left = tinState().disc;
    [true, false].forEach(function (freePass) {
      rows.forEach(function (r) {
        if (!isTin(r) || isFreeTin(r) !== freePass) return;
        var d = Math.min(left, r.original_line_price);
        r.final_line_price = r.original_line_price - d;
        left -= d;
      });
    });
  }
  function tinWord(n) { return n === 1 ? 'tin' : 'tins'; }
  function renderTins() {
    if (!b3 || !cart.item_count) return '';
    var s = tinState();
    var note = tinNote ? '<div class="pzt-note" role="status">' + esc(tinNote) + '</div>' : '';
    tinNote = '';
    if (s.need > 0) return '<div class="pzt pzt-pick" data-pzt>' + note + '<div class="pzt-loading">Loading flavors…</div></div>';
    if (!s.paid && !s.free) return note;
    var r = s.paid % s.per, more = s.earned ? ' more' : '';
    var done = s.maxed || !r;
    var dots = '';
    for (var i = 0; i < s.per; i++) dots += '<i class="' + (done || i < r ? 'on' : '') + '"></i>';
    var lim = s.limit ? '<span class="pzt-limit">Limit ' + s.limit + ' per order</span>' : '';
    var msg = s.maxed
      ? '<b>Your ' + s.earned + ' FREE tins are in.</b> ' + lim
      : (r
        ? 'Add <b>' + s.toNext + ' more ' + tinWord(s.toNext) + '</b> to unlock <b>' + s.gets + more + ' FREE</b>. ' + lim
        : '<b>' + s.free + ' FREE ' + tinWord(s.free) + '</b> in your cart. Add 3 more to unlock 2 more.');
    return '<div class="pzt pzt-prog' + (done ? ' is-done' : '') + '">' + note +
      '<div class="pzt-prog-row"><span class="pzt-badge">Buy 3 Get 2 FREE</span><span class="pzt-dots" aria-hidden="true">' + dots + '</span></div>' +
      '<div class="pzt-prog-msg">' + msg + '</div></div>';
  }
  // Flavors with at least one in-stock single tin the discount can make free
  function tinFlavors() {
    return (flavorCache || []).map(function (f) {
      var vs = f.variants.filter(function (v) { return /single/i.test(v.pack || '') && v.available && B3_GET[v.id]; })
        .sort(function (a, b) { return parseFloat(a.strength) - parseFloat(b.strength); });
      return vs.length ? { f: f, vs: vs } : null;
    }).filter(Boolean);
  }
  function drawTins() {
    var slot = body.querySelector('[data-pzt]');
    if (!slot || !flavorCache) return;
    var s = tinState(), list = tinFlavors();
    var note = slot.querySelector('.pzt-note');
    var cur = null;
    list.forEach(function (x) { if (x.f.handle === pick.flv) cur = x; });
    if (!cur) pick.v = null;
    if (cur && !cur.vs.some(function (v) { return v.id === pick.v; })) {
      var want = parseFloat(lastStrength);
      pick.v = (cur.vs.filter(function (v) { return parseFloat(v.strength) === want; })[0] || cur.vs[0]).id;
    }
    var picked = s.earned - s.need;
    slot.innerHTML = (note ? note.outerHTML : '') +
      '<div class="pzt-head"><b>Pick your ' + s.need + ' FREE ' + tinWord(s.need) + '</b>' +
      '<span>' + (picked ? picked + ' of ' + s.earned + ' picked · ' : '') + 'Buy 3 Get 2 FREE' + (s.limit ? ' · Limit ' + s.limit + ' per order' : '') + '</span></div>' +
      '<div class="pzt-grid" role="group" aria-label="Flavor">' + list.map(function (x) {
        var on = cur && x === cur;
        return '<button type="button" class="pzt-flv' + (on ? ' is-on' : '') + '" data-tin-flv="' + esc(x.f.handle) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
          '<span class="pzt-flv-img"><img src="' + esc(img(x.f.image, 160)) + '" alt="" loading="lazy"></span>' +
          '<span class="pzt-flv-name">' + esc(x.f.title.replace(/\s*nicotine pouches?\s*/i, '')) + '</span></button>';
      }).join('') + '</div>' +
      (cur
        ? '<div class="pzt-str" role="group" aria-label="Strength"><span>Strength</span>' + cur.vs.map(function (v) {
            var on = v.id === pick.v;
            return '<button type="button" class="pzt-mg' + (on ? ' is-on' : '') + '" data-tin-v="' + v.id + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(mg(v.strength)) + '</button>';
          }).join('') + '</div>' +
          '<button type="button" class="pzt-add" data-tin-add="' + pick.v + '"><s>' + money(cur.vs[0].price) + '</s> Add FREE tin</button>'
        : '<div class="pzt-hint">Tap a flavor to choose it</div>') +
      '<div class="pzt-err" data-tin-err></div>';
    if (s.need > 0 && !prevNeed && !pageRoot) slot.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    if (s.need > 0 && !prevNeed && !b3Open) { b3Open = true; track('b3g2_picker_open', { free_tins: s.need }); }
    prevNeed = s.need;
  }
  function pickTin(btn) {
    var id = parseInt(btn.getAttribute('data-tin-add'), 10);
    if (!id) return;
    busy = true;
    btn.classList.add('is-busy');
    btn.textContent = 'Adding…';
    ctx('b3g2_picker');
    add(id, 1, { _pz_free: '1' }).then(function (res) {
      if (res && res.status) {
        var err = body.querySelector('[data-tin-err]');
        if (err) err.textContent = res.description || 'That one just sold out. Pick another.';
        btn.classList.remove('is-busy');
        btn.textContent = 'Add FREE tin';
        return;
      }
      var f = (flavorCache || []).filter(function (x) { return x.handle === pick.flv; })[0];
      var v = f && f.variants.filter(function (x) { return x.id === id; })[0];
      track('free_tin_added', { flavor: f ? f.title.replace(/\s*nicotine pouches?\s*/i, '') : '', strength: v ? mg(v.strength) : '', item_id: String(id) });
      return refresh();
    }).catch(function () { return refresh(); }).finally(function () { busy = false; });
  }

  function loadFlavors() {
    if (flavorCache) return Promise.resolve(flavorCache);
    try {
      var c = JSON.parse(sessionStorage.getItem('pzc-flavors') || 'null');
      if (c && Date.now() - c.t < 5 * 60 * 1000) { flavorCache = c.d; return Promise.resolve(flavorCache); }
    } catch (e) {}
    return Promise.all((cfg.flavors || []).map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      flavorCache = list.filter(Boolean).map(function (p) {
        return {
          handle: p.handle, title: p.title, url: p.url,
          image: p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '',
          variants: p.variants.map(function (v) { return { id: v.id, strength: v.option1, pack: v.option2, price: v.price, available: v.available }; })
        };
      });
      try { sessionStorage.setItem('pzc-flavors', JSON.stringify({ t: Date.now(), d: flavorCache })); } catch (e) {}
      return flavorCache;
    });
  }

  function syncCount(n) {
    try { if (window.Alpine && Alpine.store('cart_count')) Alpine.store('cart_count').count = n; } catch (e) {}
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  // ---------- render ----------
  function itemMeta(it) {
    var opts = it.options_with_values || [];
    var strength = '', pack = '';
    opts.forEach(function (o) {
      if (/strength/i.test(o.name)) strength = o.value;
      if (/pack/i.test(o.name)) pack = o.value;
    });
    var parts = [];
    if (strength) parts.push(mg(strength));
    if (pack === ROLL) parts.push('Roll · 5 tins');
    else if (pack === CAN || /^single/i.test(pack)) parts.push('Single tin');
    else if (!strength && it.variant_title && it.variant_title !== 'Default Title') parts.push(it.variant_title);
    return { text: parts.join(' · '), strength: strength, pack: pack };
  }

  // Reward steps: Free Koozie, Free Shipping (US only), Free Hat. Steps sit evenly; the bar fills piece by piece.
  var ICONS = {
    koozie: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="13" rx="1.5"/><path d="M12 8v13M3 12h18M7.5 8C6 8 5 7 5 5.75S6 3.5 7.5 3.5C10 3.5 12 8 12 8s2-4.5 4.5-4.5C18 3.5 19 4.5 19 5.75S18 8 16.5 8"/></svg>',
    ship: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6h11v10H2zM13 9h4.5l3.5 3.5V16h-8"/><circle cx="6" cy="17.5" r="1.8" fill="#fff"/><circle cx="17" cy="17.5" r="1.8" fill="#fff"/></svg>',
    hat: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 16.5c0-5 3.4-9 7.5-9s7.5 4 7.5 9zM19.5 16.5h3M12 7.5V6M9 8.2c-.6 2.4-.8 5.2-.6 8.3"/></svg>',
    done: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    truck: '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2zM13 9h4.5l3.5 3.5V16h-8"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>'
  };
  function renderShip() {
    var sub = giftProgress();
    var kz = (tierByKey.koozie || {}).threshold || 5000, ht = (tierByKey.hat || {}).threshold || 10000;
    var steps = [
      { at: kz, base: sub, name: 'Free Koozie', short: 'a Free Koozie', icon: 'koozie' },
      { at: threshold, base: cart.items_subtotal_price, name: 'Free Shipping', short: 'Free Shipping', icon: 'ship' },
      { at: ht, base: sub, name: 'Free Hat', short: 'a Free Hat', icon: 'hat' }
    ];
    if (!usShip) steps = steps.filter(function (s) { return s.icon !== 'ship'; });
    steps.forEach(function (s) { s.on = s.base >= s.at; });
    trackRewards(steps);
    var next = null, shipStep = null;
    for (var i = 0; i < steps.length; i++) {
      if (!next && !steps[i].on) next = steps[i];
      if (steps[i].icon === 'ship') shipStep = steps[i];
    }
    var msg;
    if (!cart.item_count) msg = 'Add items to start earning rewards';
    else if (!next) msg = '<b>You unlocked every reward</b> 🎉';
    else msg = 'You\'re <b>' + money(next.at - next.base) + '</b> away from <b>' + next.short + '</b>';
    // Free shipping unlocked: a centered green banner on top of the tracker; it pops in the moment it unlocks
    var freeOn = !!(cart.item_count && shipStep && shipStep.on);
    var banner = freeOn ? '<div class="pzc-freeship' + (wasFree ? '' : ' is-new') + '" role="status" style="justify-content:center;text-align:center">' + ICONS.truck +
      '<b>You’ve Unlocked Free Shipping!</b></div>' : '';
    wasFree = freeOn;
    // Fill: each step owns an equal share of the bar
    var pct = 0, prev = 0;
    for (var j = 0; j < steps.length; j++) {
      var seg = 100 / steps.length, from = prev, to = steps[j].at;
      if (sub >= to) { pct = j === steps.length - 1 ? 100 : seg * (j + 0.5); prev = to; continue; }
      var startPct = j === 0 ? 0 : seg * (j - 0.5);
      var span = j === 0 ? seg * 0.5 : seg;
      pct = startPct + span * Math.max(0, (sub - from) / (to - from));
      break;
    }
    return '<div class="pzc-rws' + (next ? '' : ' is-done') + '">' + banner +
      '<div class="pzc-ship-text">' + msg + '</div>' +
      '<div class="pzc-track" style="grid-template-columns:repeat(' + steps.length + ',minmax(0,1fr))"><div class="pzc-track-bar"><span style="width:' + Math.min(100, Math.round(pct)) + '%"></span></div>' +
      steps.map(function (s) {
        return '<div class="pzc-rw' + (s.on ? ' is-on' : '') + '">' +
          '<span class="pzc-rw-dot">' + ICONS[s.on ? 'done' : s.icon] + '</span>' +
          '<b>' + s.name + '</b><small>Spend ' + money(s.at).replace('.00', '') + '+</small></div>';
      }).join('') + '</div></div>';
  }

  // A reward counts as unlocked once per session, the first time the cart crosses it (kept across page loads)
  function trackRewards(steps) {
    var seen = {};
    try { seen = JSON.parse(sessionStorage.getItem('pza-rw') || '{}'); } catch (e) {}
    var changed = false;
    steps.forEach(function (s) {
      if (!s.on || !cart.item_count) { if (seen[s.icon]) { seen[s.icon] = 0; changed = true; } return; }
      if (seen[s.icon]) return;
      seen[s.icon] = 1;
      changed = true;
      var value = cart.items_subtotal_price / 100;
      if (s.icon === 'ship') track('free_shipping_unlocked', { threshold: s.at / 100, value: value, currency: cart.currency });
      else track('gift_unlocked', { gift: s.icon, threshold: s.at / 100, value: value, currency: cart.currency });
    });
    if (changed) try { sessionStorage.setItem('pza-rw', JSON.stringify(seen)); } catch (e) {}
  }

  function renderGift() {
    if (!cart.item_count) return '';
    var prog = giftProgress();
    return gifts.map(function (g) {
      var opts = (g.items || []).filter(function (h) { return h.available; });
      if (!opts.length || prog < g.threshold) return '';
      return renderTier(g, opts);
    }).join('');
  }
  function renderTier(g, opts) {
    var chosen = currentGift(g);
    var chosenId = chosen ? chosen.product_id : null;
    return '<div class="pzc-gift is-on">' +
      '<div class="pzc-gift-head">' + (chosen
        ? '<b>Your free ' + esc(g.label) + ': ' + esc((itemByProduct[chosenId] || {}).name || chosen.product_title) + '</b><span>Tap another to swap</span>'
        : '<b>Free ' + esc(g.label) + ' unlocked 🎉</b><span>Pick a color, it\'s on us</span>') + '</div>' +
      '<div class="pzc-hats">' + opts.map(function (h) {
        var on = h.product_id === chosenId;
        return '<button type="button" class="pzc-hat' + (on ? ' is-on' : '') + '" data-gift="' + h.variant_id + '" data-tier="' + esc(g.key) + '"' + (on ? ' aria-pressed="true" disabled' : ' aria-pressed="false"') + '>' +
          '<span class="pzc-hat-img"><img src="' + esc(h.image) + '" alt="" loading="lazy"></span>' +
          '<span class="pzc-hat-name">' + esc(h.name) + '</span>' +
          '<span class="pzc-hat-cta">' + (on ? '✓ Added' : (chosen ? 'Swap' : 'Add free')) + '</span>' +
        '</button>';
      }).join('') + '</div></div>';
  }

  // Shopify can split one product into several lines when a discount uses part of it; show them as one row
  function groupedItems() {
    var rows = [], byKey = {};
    cart.items.forEach(function (it) {
      var gk = isGiftItem(it) || isBogos(it) ? it.key : it.variant_id + '|' + JSON.stringify(it.properties || {});
      var row = byKey[gk];
      if (!row) {
        row = byKey[gk] = Object.assign({}, it, { keys: [it.key] });
        rows.push(row);
      } else {
        row.keys.push(it.key);
        row.quantity += it.quantity;
        row.final_line_price += it.final_line_price;
        row.original_line_price += it.original_line_price;
      }
    });
    return rows;
  }

  function renderItems() {
    var rows = groupedItems();
    tinPrices(rows);
    return '<ul class="pzc-items">' + rows.map(function (it) {
      var m = itemMeta(it);
      if (isFreeTin(it)) return renderFreeTin(it, m);
      if (m.strength) lastStrength = m.strength;
      var bogos = isBogos(it);
      var giftLine = (isGiftLine(it) && it.quantity === 1) || bogos;
      // A picked koozie/hat is paid off by an order-level discount, so its line still says $6/$15: show it as free
      var gt = tierOf(it);
      var shown = giftLine && !bogos && gt && giftProgress() >= gt.threshold ? 0 : it.final_line_price;
      var imgUrl = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
      var compare = it.original_line_price > shown ? '<s>' + money(it.original_line_price) + '</s>' : '';
      var tier = tierOf(it);
      var title = tier ? tier.title + ' · ' + itemByProduct[it.product_id].name : (bogos ? cleanTitle(it.product_title) : it.product_title);
      return '<li class="pzc-item' + (giftLine ? ' is-gift' : '') + '" data-key="' + esc(it.keys.join(',')) + '">' +
        '<a class="pzc-item-img" href="' + esc(it.url) + '">' + (imgUrl ? '<img src="' + esc(img(imgUrl, 160)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="pzc-item-info">' +
          '<a class="pzc-item-title" href="' + esc(it.url) + '">' + esc(title) + '</a>' +
          (giftLine ? '<div class="pzc-item-meta pzc-gift-tag">🎁 Free gift</div>' : (m.text ? '<div class="pzc-item-meta">' + esc(m.text) + '</div>' : '')) +
          '<div class="pzc-item-row">' +
            (giftLine ? '' : '<div class="pzc-step"><button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>') +
            (bogos ? '' : '<button type="button" class="pzc-remove" data-qty="0">Remove</button>') +
          '</div>' +
          '<div class="pzc-item-err" data-err></div>' +
        '</div>' +
        '<div class="pzc-item-price">' + compare + '<b>' + (shown === 0 ? 'Free' : money(shown)) + '</b></div>' +
      '</li>';
    }).join('') + '</ul>';
  }
  // A picked free tin: no quantity stepper, FREE with the struck-through tin price
  function renderFreeTin(it, m) {
    var imgUrl = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
    var isFree = it.final_line_price === 0;
    // Shopify only takes the tins off once both free tins are in the cart
    var need = tinState().need;
    var tag = isFree || !need ? 'FREE · Buy 3 Get 2' : 'FREE once you pick ' + need + ' more';
    return '<li class="pzc-item is-gift pzt-item" data-key="' + esc(it.keys.join(',')) + '">' +
      '<a class="pzc-item-img" href="' + esc(it.url) + '">' + (imgUrl ? '<img src="' + esc(img(imgUrl, 160)) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="pzc-item-info">' +
        '<a class="pzc-item-title" href="' + esc(it.url) + '">' + esc(it.product_title) + (it.quantity > 1 ? ' × ' + it.quantity : '') + '</a>' +
        '<div class="pzc-item-meta">' + esc(m.strength ? mg(m.strength) + ' · ' : '') + '<span class="pzt-tag' + (isFree || !need ? '' : ' is-wait') + '">' + esc(tag) + '</span></div>' +
        '<div class="pzc-item-row"><button type="button" class="pzc-remove" data-qty="0">Remove</button></div>' +
        '<div class="pzc-item-err" data-err></div>' +
      '</div>' +
      '<div class="pzc-item-price">' + (it.final_line_price < it.original_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + '<b class="' + (isFree ? 'pzt-free' : '') + '">' + (isFree ? 'FREE' : money(it.final_line_price)) + '</b></div>' +
    '</li>';
  }

  // Upsell row: one roll per flavor not in the cart. Each card has four fixed strength slots (3 / 6 / 9 / 12 mg);
  // a strength that is sold out or not made leaves its slot empty so chips line up across cards.
  // A card starts on the strength already in the cart when that roll is in stock.
  var SLOTS = [3, 6, 9, 12];
  function renderUpsell(flavors) {
    if (!flavors || !flavors.length) return '';
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.handle] = true; });
    var want = parseFloat(lastStrength) || null;
    var picks = [];
    flavors.forEach(function (f) {
      if (inCart[f.handle] || picks.length >= 6) return;
      var slots = SLOTS.map(function (n) {
        for (var i = 0; i < f.variants.length; i++) {
          var x = f.variants[i];
          if (x.pack === ROLL && x.available && parseFloat(x.strength) === n) return x;
        }
        return null;
      });
      var v = null;
      slots.forEach(function (x) { if (x && !v && want && parseFloat(x.strength) === want) v = x; });
      if (!v) slots.forEach(function (x) { if (x && !v) v = x; });
      if (v) picks.push({ f: f, v: v, slots: slots });
    });
    if (!picks.length) return '';
    var heading = 'Try Something New';
    var arrow = function (dir, label, d) { return '<button type="button" class="pzc-up-arrow" data-up-dir="' + dir + '" aria-label="' + label + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg></button>'; };
    return '<div class="pzc-up"><div class="pzc-up-top"><div class="pzc-up-head">' + heading + '</div>' +
      (picks.length > 2 ? '<div class="pzc-up-nav">' + arrow(-1, 'Scroll left', 'M15 6l-6 6 6 6') + arrow(1, 'Scroll right', 'M9 6l6 6-6 6') + '</div>' : '') +
      '</div><div class="pzc-up-row">' + picks.map(function (p) {
      return '<div class="pzc-up-card">' +
        '<a href="' + esc(p.f.url) + '" class="pzc-up-img"><img src="' + esc(img(p.f.image, 240)) + '" alt="' + esc(p.f.title) + '" loading="lazy"></a>' +
        '<div class="pzc-up-name">' + esc(p.f.title) + '</div>' +
        '<div class="pzc-up-mgs" role="group" aria-label="' + esc(p.f.title) + ' strength">' + p.slots.map(function (r) {
          if (!r) return '<i aria-hidden="true"></i>';
          var on = r.id === p.v.id;
          return '<button type="button" class="pzc-up-mg' + (on ? ' is-on' : '') + '" data-up-v="' + r.id + '" data-price="' + r.price + '" aria-pressed="' + on + '" aria-label="' + esc(mg(r.strength)) + '">' + parseFloat(r.strength) + '</button>';
        }).join('') + '</div>' +
        '<div class="pzc-up-meta">1 Roll</div>' +
        '<button type="button" class="pzc-up-add" data-add="' + p.v.id + '">+ Add ' + money(p.v.price) + '</button>' +
      '</div>';
    }).join('') + '</div></div>';
  }
  function drawUpsell() {
    var slot = body.querySelector('[data-pzc-up]');
    if (!slot || !flavorCache) return;
    slot.innerHTML = renderUpsell(flavorCache);
    var row = slot.querySelector('.pzc-up-row');
    if (row) { syncArrows(row); row.addEventListener('scroll', function () { syncArrows(row); }, { passive: true }); enableDrag(row); }
  }

  function renderFoot() {
    if (!cart.item_count) { foot.innerHTML = ''; foot.hidden = true; return; }
    foot.hidden = false;
    var free = usShip && cart.items_subtotal_price >= threshold;
    var disc = cart.original_total_price > cart.total_price ? '<div class="pzc-line"><span>Discounts</span><span>−' + money(cart.original_total_price - cart.total_price) + '</span></div>' : '';
    foot.innerHTML =
      '<div class="pzc-line"><span>Subtotal</span><b>' + money(cart.original_total_price) + '</b></div>' + disc +
      '<div class="pzc-line pzc-muted"><span>Shipping</span>' + (free ? '<span class="pzc-free-val">FREE</span>' : '<span>Calculated at checkout</span>') + '</div>' +
      '<a class="pzc-checkout" href="/checkout"><span class="pzc-lockup"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>Secure Checkout</span></a>' +
      '<div class="pzc-trust"><span>📦 Ships in 1 Business Day</span><span>🛡️ 30-Day Money Back Guarantee</span></div>';
  }

  function render() {
    countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    syncCount(cart.item_count);
    rwEl.innerHTML = renderShip();
    var html = renderTins() + renderGift();
    if (cart.item_count) html += renderItems();
    else html += '<div class="pzc-empty"><b>Your cart is empty.</b><span>Pick a flavor to get started.</span></div>';
    html += '<div data-pzc-up></div>';
    body.innerHTML = html;
    renderFoot();
    if (!body.querySelector('[data-pzt]')) prevNeed = 0;
    var ts = tinState();
    if (b3Open && !ts.need) {
      b3Open = false;
      if (ts.earned && ts.free >= ts.earned) track('b3g2_complete', { free_tins: ts.free });
    }
    loadFlavors().then(function () { drawTins(); drawUpsell(); });
  }

  // Every cart update goes through here so the free-hat rules are applied before drawing
  function sig(c) { return c ? c.items.map(function (it) { return it.key + ':' + it.quantity; }).join('|') + '#' + c.total_price : ''; }
  var recheckTimer = null;
  function settle(c, again) {
    cart = c;
    return enforceGift().then(function (g) {
      return enforceTins().then(function (t) { return g || t; });
    }).then(function (changed) {
      if (!changed) return cart;
      return getCart().then(function (c2) { cart = c2; return cart; });
    }).then(function () {
      render();
      // Apps can add or drop lines a moment after a change; look again once and redraw if they did
      if (!again) {
        clearTimeout(recheckTimer);
        var before = sig(cart);
        recheckTimer = setTimeout(function () {
          getCart().then(function (c3) { if (sig(c3) !== before) settle(c3, true); });
        }, 1800);
      }
      return cart;
    });
  }
  function refresh() {
    return getCart().then(settle);
  }

  function pickGift(btn) {
    var variantId = parseInt(btn.getAttribute('data-gift'), 10);
    var key = btn.getAttribute('data-tier');
    var prev = cart.items.filter(function (it) { var t = tierOf(it); return t && t.key === key && it.properties && it.properties._pz_gift; });
    busy = true;
    btn.classList.add('is-busy');
    btn.querySelector('.pzc-hat-cta').textContent = 'Adding…';
    prev.reduce(function (p, it) { return p.then(function () { return change(it.key, 0); }); }, Promise.resolve())
      .then(function () { ctx('gift_picker'); return add(variantId, 1, { _pz_gift: key }); })
      .then(function (res) {
        if (res && res.status) btn.querySelector('.pzc-hat-cta').textContent = 'Sold out';
        else track('gift_picked', { gift: key, item_name: btn.querySelector('.pzc-hat-name').textContent, item_id: String(variantId), swap: prev.length ? true : undefined });
        return refresh();
      })
      .catch(function () { return refresh(); })
      .finally(function () { busy = false; });
  }

  // Upsell row: drag sideways with the mouse (touch already swipes natively); a drag never counts as a click
  function enableDrag(row) {
    var down = false, moved = false, sx = 0, sl = 0;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; sx = e.clientX; sl = row.scrollLeft;
    });
    row.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        row.classList.add('is-dragging');
        try { row.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (moved) { row.scrollLeft = sl - dx; e.preventDefault(); }
    });
    function end() {
      if (!down) return;
      down = false;
      if (moved) { row.classList.remove('is-dragging'); setTimeout(function () { moved = false; }, 0); }
    }
    row.addEventListener('pointerup', end);
    row.addEventListener('pointercancel', end);
    row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  // Upsell arrows: grey out the one that can't scroll further
  function syncArrows(row) {
    var up = row.closest('.pzc-up');
    var l = up.querySelector('[data-up-dir="-1"]'), r = up.querySelector('[data-up-dir="1"]');
    if (!l || !r) return;
    l.disabled = row.scrollLeft <= 2;
    r.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
  }

  // ---------- interactions ----------
  body.addEventListener('click', function (e) {
    var arr = e.target.closest('[data-up-dir]');
    if (arr) {
      var row = arr.closest('.pzc-up').querySelector('.pzc-up-row');
      row.scrollBy({ left: parseInt(arr.getAttribute('data-up-dir'), 10) * (row.clientWidth - 40), behavior: 'smooth' });
      return;
    }
    // Upsell mg chip: swap that card's variant and price
    var mgb = e.target.closest('[data-up-v]');
    if (mgb) {
      var card = mgb.closest('.pzc-up-card');
      card.querySelectorAll('[data-up-v]').forEach(function (b) { var on = b === mgb; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var ab = card.querySelector('[data-add]');
      if (ab && !ab.classList.contains('is-busy')) {
        ab.setAttribute('data-add', mgb.getAttribute('data-up-v'));
        ab.textContent = '+ Add ' + money(parseInt(mgb.getAttribute('data-price'), 10));
      }
      return;
    }
    // Free-tin picker: choose a flavor, then a strength, then add
    var tf = e.target.closest('[data-tin-flv]');
    if (tf) { pick.flv = tf.getAttribute('data-tin-flv'); pick.v = null; drawTins(); return; }
    var tv = e.target.closest('[data-tin-v]');
    if (tv) { pick.v = parseInt(tv.getAttribute('data-tin-v'), 10); drawTins(); return; }
    var ta = e.target.closest('[data-tin-add]');
    if (ta && !busy) { pickTin(ta); return; }
    var q = e.target.closest('[data-qty]');
    if (q && !busy) {
      var li = q.closest('[data-key]');
      var qty = Math.max(0, parseInt(q.getAttribute('data-qty'), 10));
      busy = true;
      li.classList.add('is-busy');
      ctx(pageRoot ? 'cart_page' : 'cart_drawer');
      setRowQty(li.getAttribute('data-key').split(','), qty).then(function (res) {
        if (res.status || res.message && !res.items) {
          var err = li.querySelector('[data-err]');
          if (err) err.textContent = res.description || res.message || 'Could not update.';
          li.classList.remove('is-busy');
          return;
        }
        return settle(res);
      }).catch(function () { li.classList.remove('is-busy'); }).finally(function () { busy = false; });
      return;
    }
    var gb = e.target.closest('[data-gift]');
    if (gb && !busy && !gb.disabled) { pickGift(gb); return; }
    var a = e.target.closest('[data-add]');
    if (a && !busy) {
      busy = true;
      a.classList.add('is-busy');
      a.textContent = 'Adding…';
      ctx('cart_upsell');
      add(parseInt(a.getAttribute('data-add'), 10), 1).then(function (res) {
        if (res.status) { a.textContent = 'Sold out'; return; }
        return refresh();
      }).finally(function () { busy = false; });
    }
  });

  var lastFocus = null;
  function open() {
    if (pageRoot) return refresh();
    lastFocus = document.activeElement;
    if (!drawer.classList.contains('is-open')) track('cart_drawer_open');
    drawer.classList.add('is-open');
    document.documentElement.classList.add('pzc-lock');
    drawer.querySelector('.pzc-panel').focus();
    return refresh().then(function (c) {
      if (c && window.PZA && window.PZA.trackCart) window.PZA.trackCart('view_cart', c, { cart_type: 'drawer' });
      return c;
    });
  }
  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('pzc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (!pageRoot) {
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-pzc-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    // Header cart links open the drawer instead of leaving the page
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="/cart"], a[href$="/cart"]');
      if (!link || drawer.contains(link) || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      e.stopPropagation();
      open();
    }, true);
  } else {
    refresh();
  }

  // Other scripts (product page add to cart, apps) change the cart too: redraw when they do
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var extTimer = null;
  function onExternal() {
    clearTimeout(extTimer);
    extTimer = setTimeout(function () { if (pageRoot || drawer.classList.contains('is-open')) refresh(); else getCart().then(function (c) { syncCount(c.item_count); }); }, 350);
  }
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var p = nativeFetch.apply(this, arguments);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_RE.test(u) && !(init && init.pzc)) p.then(onExternal, function () {});
    } catch (e) {}
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    try { if (CART_RE.test(String(u))) this.addEventListener('load', onExternal); } catch (e) {}
    return xOpen.apply(this, arguments);
  };

  window.PZCart = { open: open, close: close, refresh: refresh };
})();
